export default __webpack_public_path__ + "2db4e4660a6c6785067b5d05031dadb3.png";